import { useEffect, useState, useContext } from "react";
import {
  Box,
  Grid,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Typography,
  TableContainer,
} from "@mui/material";
//Srcs
import "../../Style/pagestyle.scss";
import EmptyData from "../../Components/Include/EmptyData/EmptyData";
import LoadingPage from "../../Utils/LoadingPage";
import FooterPagination from "../../Utils/FooterPagination";
import { AuthContext } from "../../Context/AuthContext";
import {
  SearchTextField,
  ButtonCreate,
  PageHeaderTitle,
} from "../../Utils/Component";
import ExamTypeForm from "../../Components/StudyClass/Exam/ExamTypeForm/ExamTypeForm";
import ExamTypeAction from "../../Components/StudyClass/Exam/ExamTypeForm/ExamTypeAction";
import useGetExamTypePagination from "../../Hooks/useGetExamTypePagination";
import useWithDimension from "../../Hooks/useWithDimension";

export default function ExamType() {
  // Change Language
  const { t, language } = useContext(AuthContext);
  const { width } = useWithDimension();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const {
    page,
    limit,
    loading,
    refetch,
    setPage,
    tableData,
    setLoading,
    handleLimit,
    handleSearch,
    paginationData,
  } = useGetExamTypePagination();

  return (
    <div className="page-container">
      <PageHeaderTitle
        classPage={t("class-page-title")}
        classSlash="slash-title"
        routeTo={"/setting"}
        pageTitle={t("page_setting")}
        detailTitle={t("page_exam_type")}
      />

      <Box sx={{ marginTop: "20px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("search")}
            </Typography>
            <SearchTextField
              className={"text-field"}
              handleSearch={handleSearch}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={8} lg={9} xl={10}>
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn={"btn-create"}
              classIcon={"icon-add"}
            />

            {open && (
              <ExamTypeForm
                open={open}
                handleClose={handleClose}
                setRefetch={refetch}
                dialogTitle={"Create"}
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table">
            <TableHead className="header-row">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width="5%"
                >
                  {t("thead_no")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="20%">
                  {t("thead_exam")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="20%">
                  {t("thead_class")}
                </TableCell>
                {/* <TableCell className={t("class-name-header-title")} width="20%">
                  {t("thead_subject")}
                </TableCell> */}
                <TableCell className={t("class-name-header-title")} width="20%">
                  {t("thead_remark")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title-end")}
                  width="15%"
                ></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={10} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 || tableData?.length === undefined ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={10} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      return (
                        <TableRow className={"body-row"} key={index}>
                          <TableCell className="body-cell-start">
                            {index + paginationData?.slNo}
                          </TableCell>

                          <TableCell className="body-cell">
                            {row?.examName}
                          </TableCell>
                          <TableCell className="body-cell">
                            {language === "en"
                              ? row?.classId?.courseId?.enName
                              : row?.classId?.courseId?.khName}{" "}
                            {row?.classId?.className}
                          </TableCell>

                          {/* <TableCell className="body-cell">
                            <Stack
                              spacing={0.7}
                              direction="row"
                              alignItems="center"
                            >
                              {row?.subjectScore?.map((e, index) => (
                                <Typography
                                  key={index}
                                  sx={{
                                    color: `${
                                      colors[index % colors.length]
                                    } !important`,
                                  }}
                                >
                                  {language === "en"
                                    ? e?.subjectId?.enName
                                    : e?.subjectId?.khName}
                                  ,
                                </Typography>
                              ))}
                            </Stack>
                          </TableCell> */}
                          <TableCell className="body-cell">
                            {row?.remark}
                          </TableCell>

                          <TableCell className="body-cell-end" align="right">
                            <ExamTypeAction
                              editData={row}
                              setRefetch={refetch}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
          Type="student"
        />
      </Box>
    </div>
  );
}
